import { Component } from '@angular/core';

@Component({
  selector: 'app-interfaces-index',
  templateUrl: './interfaces-index.component.html',
  styleUrls: ['./interfaces-index.component.scss']
})
export class InterfacesIndexComponent {

}
